exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-info[data-v-678a39d6]{vertical-align:middle;color:#bdbdbd}.icon-info[data-v-678a39d6]:hover{color:#ff5722}", ""]);

// exports
